import { Navigate, useParams } from 'react-router-dom';

/**
 * Downloads moved onto the order's gallery; links and bookmarks to the old
 * download page land there instead.
 */
export function LegacyDownloadRedirect() {
  const { orderId } = useParams<{ orderId: string }>();
  return <Navigate to={orderId ? `/orders/${orderId}` : '/orders'} replace />;
}
